/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateBotExamLangViewModel } from "../types/UpdateBotExamLangViewModel.ts";

export const updateBotExamLangViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe(
      "Novo código de cultura do idioma. Deve ser um dos valores permitidos: pt-BR, en-US, es-ES. Máximo 10 caracteres.",
    )
    .nullish(),
  title: z
    .string()
    .describe("Título da prova bot neste idioma. Máximo 300 caracteres.")
    .nullish(),
  instruction: z
    .string()
    .describe("Instrução geral da prova bot neste idioma.")
    .nullish(),
  active: z.optional(z.boolean().describe("Define se este idioma está ativo.")),
}) as unknown as ToZod<UpdateBotExamLangViewModel>;
